import { render, staticRenderFns } from "./ap.vue?vue&type=template&id=8c54abd8&scoped=true&"
import script from "./ap.vue?vue&type=script&lang=js&"
export * from "./ap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c54abd8",
  null
  
)

export default component.exports